import {SidebarConfigCallToAction} from '@github-ui/code-view-sidebar/components/SidebarConfigCallToAction'
import {
  combinedSidebarPayloadQueryKey,
  useCombinedSidebarPayload,
} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useQueryClient} from '@github-ui/react-query'

interface SidebarCTAProps {
  ownerLogin: string
  repoName: string
}

export function SidebarCTA({ownerLogin, repoName}: SidebarCTAProps) {
  const {configCallToAction} = useCombinedSidebarPayload(ownerLogin, repoName)
  const queryClient = useQueryClient()

  if (!configCallToAction) return null

  return (
    <SidebarConfigCallToAction
      {...configCallToAction}
      onOptIn={() => {
        queryClient.invalidateQueries({queryKey: combinedSidebarPayloadQueryKey(ownerLogin, repoName)})
      }}
    />
  )
}
